import React from "react";
import ReactTooltip from "react-tooltip";

function CustomToolTip(props) {
    const { id, title, place="top", effect="solid" } = props;
  return (
    <ReactTooltip id={id} place={place} effect={effect}>
      {title}
    </ReactTooltip>
  );
}

export default CustomToolTip;
